/**
 * Available hooks
 *
 * component.initialized(component)
 * elementInitialized(el, component)
 * element.removed(el, component)
 * message.sent(component, message)
 * message.failed(component)
 * message.received(component, response)
 * message.received(component, mutableHtmlContainer)
 * beforeElementUpdate(from, to, component)
 * element.updated(node, component)
 * message.processed(component)
 * interceptWireModelSetValue(el, value)
 * interceptWireModelAttachListener(el, directive, component, debounceIf)
 * directive(el, directive, component)
 *
 */

export default function() {
    window.Livewire.directive('confirm', (el, directive, component) => {
        const modelString = directive.method;
        const params = directive.params;
        const modelBind = directive.modifiers[0];
        const message = el.getAttribute('data-confirm-message') ? el.getAttribute('data-confirm-message') : 'Are you sure?';
        const confirmButton = el.getAttribute('data-confirm-button') ? el.getAttribute('data-confirm-button') : 'Yes';
        const noButton = el.getAttribute('data-cancel-button') ? el.getAttribute('data-cancel-button') : 'No';
        const subMessage = el.getAttribute('data-confirm-submessage') ? el.getAttribute('data-confirm-submessage') : null;

        el.addEventListener(modelBind, function(event) {
            event.preventDefault();
            swalc(
                [message, subMessage],
                (confirm) => {
                    if (confirm) {
                        component.call(modelString, ...params);
                    }
                },
                {
                    cancelButtonText: noButton,
                    confirmButtonText: confirmButton,
                },
            );
        });
    });
}
